import { useNavigate } from "react-router-dom";
import { COMPANY_INFO } from "@/lib/companyInfo";
import { reopenBanner } from "@/lib/consent";

const AppFooter = () => {
  const navigate = useNavigate();

  const footerLinks = [
    { label: "Termeni și Condiții", path: "/terms" },
    { label: "Confidențialitate", path: "/privacy" },
    { label: "Contact", path: "/contact" },
  ];

  return (
    <footer className="py-10 px-4 border-t border-border">
      <div className="container flex flex-col sm:flex-row justify-between items-center gap-6">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
          className="font-heading font-bold text-primary hover:opacity-80 transition-opacity cursor-pointer"
        >
          {COMPANY_INFO.brandName}
        </a>
        <nav className="flex items-center gap-4 sm:gap-6 flex-wrap justify-center">
          {footerLinks.map((link) => (
            <a
              key={link.path}
              href={link.path}
              onClick={(e) => {
                e.preventDefault();
                navigate(link.path);
              }}
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              {link.label}
            </a>
          ))}
          <button
            type="button"
            onClick={() => reopenBanner()}
            className="text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            Cookie-uri
          </button>
        </nav>
        <p className="text-sm text-muted-foreground">
          © {COMPANY_INFO.copyrightYear} {COMPANY_INFO.brandName}. Toate drepturile rezervate.
        </p>
      </div>
    </footer>
  );
};

export default AppFooter;
